// extracted by mini-css-extract-plugin
module.exports = {"centerChat":"_3XeIJ","loading":"_2xfKZ","alertText":"_3ZMEg"};